export default __webpack_public_path__ + "static/media/InterFontIcons.c677618c.ttf";